var ErrCode = /* @__PURE__ */ ((ErrCode2) => {
  ErrCode2[ErrCode2["SUCCESS"] = 0] = "SUCCESS";
  ErrCode2[ErrCode2["PARAM_INVALID"] = 1001] = "PARAM_INVALID";
  ErrCode2[ErrCode2["UNAUTHORIZED"] = 1002] = "UNAUTHORIZED";
  ErrCode2[ErrCode2["FORBIDDEN"] = 1003] = "FORBIDDEN";
  ErrCode2[ErrCode2["NOT_FOUND"] = 1004] = "NOT_FOUND";
  ErrCode2[ErrCode2["TOO_FREQUENT"] = 1005] = "TOO_FREQUENT";
  ErrCode2[ErrCode2["IDEMPOTENCY_KEY_MISSING"] = 1006] = "IDEMPOTENCY_KEY_MISSING";
  ErrCode2[ErrCode2["SMS_CODE_INVALID"] = 1101] = "SMS_CODE_INVALID";
  ErrCode2[ErrCode2["SMS_CODE_EXPIRED"] = 1102] = "SMS_CODE_EXPIRED";
  ErrCode2[ErrCode2["PHONE_INVALID"] = 1103] = "PHONE_INVALID";
  ErrCode2[ErrCode2["USER_BLOCKED"] = 1104] = "USER_BLOCKED";
  ErrCode2[ErrCode2["ACCOUNT_BIND_CONFLICT"] = 1105] = "ACCOUNT_BIND_CONFLICT";
  ErrCode2[ErrCode2["NEED_BIND_PHONE"] = 1106] = "NEED_BIND_PHONE";
  ErrCode2[ErrCode2["TOKEN_EXPIRED"] = 1107] = "TOKEN_EXPIRED";
  ErrCode2[ErrCode2["REFRESH_TOKEN_REUSED"] = 1108] = "REFRESH_TOKEN_REUSED";
  ErrCode2[ErrCode2["NEED_INVITE_CODE"] = 1109] = "NEED_INVITE_CODE";
  ErrCode2[ErrCode2["INVITE_CODE_INVALID"] = 1110] = "INVITE_CODE_INVALID";
  ErrCode2[ErrCode2["INVITE_CODE_USED"] = 1111] = "INVITE_CODE_USED";
  ErrCode2[ErrCode2["INVITE_CODE_DISABLED"] = 1112] = "INVITE_CODE_DISABLED";
  ErrCode2[ErrCode2["INVITE_CODE_EXPIRED"] = 1113] = "INVITE_CODE_EXPIRED";
  ErrCode2[ErrCode2["PASSWORD_WEAK"] = 1114] = "PASSWORD_WEAK";
  ErrCode2[ErrCode2["PASSWORD_WRONG"] = 1115] = "PASSWORD_WRONG";
  ErrCode2[ErrCode2["LOGIN_LOCKED"] = 1116] = "LOGIN_LOCKED";
  ErrCode2[ErrCode2["SMS_LOGIN_DISABLED"] = 1117] = "SMS_LOGIN_DISABLED";
  ErrCode2[ErrCode2["NEED_SET_PASSWORD"] = 1118] = "NEED_SET_PASSWORD";
  ErrCode2[ErrCode2["BIND_NEED_PASSWORD"] = 1119] = "BIND_NEED_PASSWORD";
  ErrCode2[ErrCode2["MEMBER_FEATURE_DISABLED"] = 1120] = "MEMBER_FEATURE_DISABLED";
  ErrCode2[ErrCode2["VIP_ONLY"] = 1121] = "VIP_ONLY";
  ErrCode2[ErrCode2["VIP_TIER_DISABLED"] = 1122] = "VIP_TIER_DISABLED";
  ErrCode2[ErrCode2["ALREADY_VIP"] = 1123] = "ALREADY_VIP";
  ErrCode2[ErrCode2["PRODUCT_OFF_SHELF"] = 2001] = "PRODUCT_OFF_SHELF";
  ErrCode2[ErrCode2["PRODUCT_NOT_FOUND"] = 2002] = "PRODUCT_NOT_FOUND";
  ErrCode2[ErrCode2["STOCK_NOT_ENOUGH"] = 2003] = "STOCK_NOT_ENOUGH";
  ErrCode2[ErrCode2["SKU_NOT_FOUND"] = 2004] = "SKU_NOT_FOUND";
  ErrCode2[ErrCode2["ORDER_NOT_FOUND"] = 3001] = "ORDER_NOT_FOUND";
  ErrCode2[ErrCode2["ORDER_STATUS_INVALID"] = 3002] = "ORDER_STATUS_INVALID";
  ErrCode2[ErrCode2["DUPLICATE_SUBMIT"] = 3003] = "DUPLICATE_SUBMIT";
  ErrCode2[ErrCode2["PURCHASE_LIMIT_EXCEEDED"] = 3004] = "PURCHASE_LIMIT_EXCEEDED";
  ErrCode2[ErrCode2["CART_EMPTY"] = 3005] = "CART_EMPTY";
  ErrCode2[ErrCode2["ADDRESS_NOT_FOUND"] = 3006] = "ADDRESS_NOT_FOUND";
  ErrCode2[ErrCode2["COUPON_UNAVAILABLE"] = 3101] = "COUPON_UNAVAILABLE";
  ErrCode2[ErrCode2["COUPON_BELOW_THRESHOLD"] = 3102] = "COUPON_BELOW_THRESHOLD";
  ErrCode2[ErrCode2["COUPON_ALREADY_USED"] = 3103] = "COUPON_ALREADY_USED";
  ErrCode2[ErrCode2["POINTS_NOT_ENOUGH"] = 3104] = "POINTS_NOT_ENOUGH";
  ErrCode2[ErrCode2["POINTS_OVER_LIMIT"] = 3105] = "POINTS_OVER_LIMIT";
  ErrCode2[ErrCode2["AMOUNT_VERIFY_FAILED"] = 3106] = "AMOUNT_VERIFY_FAILED";
  ErrCode2[ErrCode2["PAYMENT_NOT_FOUND"] = 4001] = "PAYMENT_NOT_FOUND";
  ErrCode2[ErrCode2["ORDER_ALREADY_PAID"] = 4002] = "ORDER_ALREADY_PAID";
  ErrCode2[ErrCode2["NO_AVAILABLE_PAY_METHOD"] = 4003] = "NO_AVAILABLE_PAY_METHOD";
  ErrCode2[ErrCode2["CHANNEL_CREATE_ORDER_FAILED"] = 4004] = "CHANNEL_CREATE_ORDER_FAILED";
  ErrCode2[ErrCode2["CHANNEL_RESPONSE_INVALID"] = 4005] = "CHANNEL_RESPONSE_INVALID";
  ErrCode2[ErrCode2["CHANNEL_NOT_CONFIGURED"] = 4006] = "CHANNEL_NOT_CONFIGURED";
  ErrCode2[ErrCode2["CALLBACK_VERIFY_FAILED"] = 4007] = "CALLBACK_VERIFY_FAILED";
  ErrCode2[ErrCode2["CALLBACK_AMOUNT_MISMATCH"] = 4008] = "CALLBACK_AMOUNT_MISMATCH";
  ErrCode2[ErrCode2["REFUND_AMOUNT_EXCEEDED"] = 5001] = "REFUND_AMOUNT_EXCEEDED";
  ErrCode2[ErrCode2["ORDER_NOT_REFUNDABLE"] = 5002] = "ORDER_NOT_REFUNDABLE";
  ErrCode2[ErrCode2["CHANNEL_REFUND_FAILED"] = 5003] = "CHANNEL_REFUND_FAILED";
  ErrCode2[ErrCode2["REFUND_NOT_FOUND"] = 5004] = "REFUND_NOT_FOUND";
  ErrCode2[ErrCode2["EXPRESS_NOT_CONFIGURED"] = 6001] = "EXPRESS_NOT_CONFIGURED";
  ErrCode2[ErrCode2["WAYBILL_CREATE_FAILED"] = 6002] = "WAYBILL_CREATE_FAILED";
  ErrCode2[ErrCode2["EXPRESS_RESPONSE_INVALID"] = 6003] = "EXPRESS_RESPONSE_INVALID";
  ErrCode2[ErrCode2["EXPRESS_SIGN_FAILED"] = 6004] = "EXPRESS_SIGN_FAILED";
  ErrCode2[ErrCode2["WAYBILL_CANCEL_FAILED"] = 6005] = "WAYBILL_CANCEL_FAILED";
  ErrCode2[ErrCode2["WAYBILL_NOT_FOUND"] = 6006] = "WAYBILL_NOT_FOUND";
  ErrCode2[ErrCode2["WAYBILL_ALREADY_EXISTS"] = 6007] = "WAYBILL_ALREADY_EXISTS";
  ErrCode2[ErrCode2["EXPRESS_SENDER_INCOMPLETE"] = 6008] = "EXPRESS_SENDER_INCOMPLETE";
  ErrCode2[ErrCode2["EXPRESS_TEMPLATE_MISSING"] = 6009] = "EXPRESS_TEMPLATE_MISSING";
  ErrCode2[ErrCode2["WAYBILL_NOT_PRINTABLE"] = 6010] = "WAYBILL_NOT_PRINTABLE";
  ErrCode2[ErrCode2["SYSTEM_BUSY"] = 9001] = "SYSTEM_BUSY";
  ErrCode2[ErrCode2["DOWNSTREAM_TIMEOUT"] = 9002] = "DOWNSTREAM_TIMEOUT";
  ErrCode2[ErrCode2["NOT_IMPLEMENTED"] = 9003] = "NOT_IMPLEMENTED";
  return ErrCode2;
})(ErrCode || {});
const ERR_MESSAGE = {
  [0 /* SUCCESS */]: "ok",
  [1001 /* PARAM_INVALID */]: "\u53C2\u6570\u6709\u8BEF",
  [1002 /* UNAUTHORIZED */]: "\u8BF7\u5148\u767B\u5F55",
  [1003 /* FORBIDDEN */]: "\u6CA1\u6709\u6743\u9650\u6267\u884C\u6B64\u64CD\u4F5C",
  [1004 /* NOT_FOUND */]: "\u5185\u5BB9\u4E0D\u5B58\u5728",
  [1005 /* TOO_FREQUENT */]: "\u64CD\u4F5C\u8FC7\u4E8E\u9891\u7E41\uFF0C\u8BF7\u7A0D\u540E\u518D\u8BD5",
  [1006 /* IDEMPOTENCY_KEY_MISSING */]: "\u7F3A\u5C11\u5E42\u7B49\u6807\u8BC6",
  [1101 /* SMS_CODE_INVALID */]: "\u9A8C\u8BC1\u7801\u9519\u8BEF",
  [1102 /* SMS_CODE_EXPIRED */]: "\u9A8C\u8BC1\u7801\u5DF2\u8FC7\u671F\uFF0C\u8BF7\u91CD\u65B0\u83B7\u53D6",
  [1103 /* PHONE_INVALID */]: "\u624B\u673A\u53F7\u683C\u5F0F\u4E0D\u6B63\u786E",
  [1104 /* USER_BLOCKED */]: "\u8D26\u53F7\u5DF2\u88AB\u9650\u5236\uFF0C\u8BF7\u8054\u7CFB\u5BA2\u670D",
  [1105 /* ACCOUNT_BIND_CONFLICT */]: "\u8BE5\u624B\u673A\u53F7\u5DF2\u7ED1\u5B9A\u5176\u4ED6\u8D26\u53F7\uFF0C\u8BF7\u8054\u7CFB\u5BA2\u670D\u5904\u7406",
  [1106 /* NEED_BIND_PHONE */]: "\u8BF7\u5148\u7ED1\u5B9A\u624B\u673A\u53F7",
  [1107 /* TOKEN_EXPIRED */]: "\u767B\u5F55\u5DF2\u8FC7\u671F\uFF0C\u8BF7\u91CD\u65B0\u767B\u5F55",
  [1108 /* REFRESH_TOKEN_REUSED */]: "\u767B\u5F55\u72B6\u6001\u5F02\u5E38\uFF0C\u8BF7\u91CD\u65B0\u767B\u5F55",
  [1109 /* NEED_INVITE_CODE */]: "\u9996\u6B21\u767B\u5F55\u9700\u8981\u9080\u8BF7\u7801",
  [1110 /* INVITE_CODE_INVALID */]: "\u9080\u8BF7\u7801\u65E0\u6548\uFF0C\u8BF7\u6838\u5BF9\u540E\u91CD\u8BD5",
  [1111 /* INVITE_CODE_USED */]: "\u8BE5\u9080\u8BF7\u7801\u5DF2\u88AB\u4F7F\u7528",
  [1112 /* INVITE_CODE_DISABLED */]: "\u8BE5\u9080\u8BF7\u7801\u5DF2\u505C\u7528",
  [1113 /* INVITE_CODE_EXPIRED */]: "\u8BE5\u9080\u8BF7\u7801\u5DF2\u8FC7\u671F",
  [1114 /* PASSWORD_WEAK */]: "\u5BC6\u7801\u9700 8-32 \u4F4D\uFF0C\u4E14\u5FC5\u987B\u540C\u65F6\u5305\u542B\u5B57\u6BCD\u548C\u6570\u5B57",
  // ⚠️ 「账号不存在」与「密码错误」共用同一句文案：这是刻意的（避免手机号枚举）
  [1115 /* PASSWORD_WRONG */]: "\u624B\u673A\u53F7\u6216\u5BC6\u7801\u9519\u8BEF",
  [1116 /* LOGIN_LOCKED */]: "\u8FDE\u7EED\u767B\u5F55\u5931\u8D25\u6B21\u6570\u8FC7\u591A\uFF0C\u8D26\u53F7\u5DF2\u4E34\u65F6\u9501\u5B9A\uFF0C\u8BF7\u7A0D\u540E\u518D\u8BD5",
  [1117 /* SMS_LOGIN_DISABLED */]: "\u77ED\u4FE1\u767B\u5F55\u6682\u672A\u5F00\u653E\uFF0C\u8BF7\u4F7F\u7528\u624B\u673A\u53F7 + \u5BC6\u7801\u767B\u5F55",
  [1118 /* NEED_SET_PASSWORD */]: "\u8BE5\u8D26\u53F7\u8FD8\u6CA1\u6709\u8BBE\u7F6E\u5BC6\u7801",
  [1119 /* BIND_NEED_PASSWORD */]: "\u8BE5\u624B\u673A\u53F7\u5DF2\u6709\u8D26\u53F7\uFF0C\u8BF7\u586B\u5199\u8BE5\u8D26\u53F7\u7684\u5BC6\u7801\u540E\u7ED1\u5B9A",
  [1120 /* MEMBER_FEATURE_DISABLED */]: "\u4F1A\u5458\u529F\u80FD\u6682\u672A\u5F00\u653E",
  [1121 /* VIP_ONLY */]: "\u8BE5\u5546\u54C1\u4E3A VIP \u4E13\u5C5E\uFF0C\u5347\u7EA7 VIP \u540E\u5373\u53EF\u67E5\u770B",
  [1122 /* VIP_TIER_DISABLED */]: "VIP \u5347\u7EA7\u529F\u80FD\u6682\u672A\u5F00\u653E\uFF0C\u8BF7\u8054\u7CFB\u5BA2\u670D",
  [1123 /* ALREADY_VIP */]: "\u5F53\u524D\u8D26\u53F7\u5DF2\u662F VIP\uFF0C\u65E0\u9700\u91CD\u590D\u5347\u7EA7",
  [2001 /* PRODUCT_OFF_SHELF */]: "\u5546\u54C1\u5DF2\u4E0B\u67B6",
  [2002 /* PRODUCT_NOT_FOUND */]: "\u5546\u54C1\u4E0D\u5B58\u5728",
  [2003 /* STOCK_NOT_ENOUGH */]: "\u5E93\u5B58\u4E0D\u8DB3",
  [2004 /* SKU_NOT_FOUND */]: "\u89C4\u683C\u4E0D\u5B58\u5728",
  [3001 /* ORDER_NOT_FOUND */]: "\u8BA2\u5355\u4E0D\u5B58\u5728",
  [3002 /* ORDER_STATUS_INVALID */]: "\u5F53\u524D\u72B6\u6001\u4E0D\u652F\u6301\u6B64\u64CD\u4F5C",
  [3003 /* DUPLICATE_SUBMIT */]: "\u8BF7\u52FF\u91CD\u590D\u63D0\u4EA4",
  [3004 /* PURCHASE_LIMIT_EXCEEDED */]: "\u8D85\u51FA\u9650\u8D2D\u6570\u91CF",
  [3005 /* CART_EMPTY */]: "\u8BF7\u5148\u9009\u62E9\u5546\u54C1",
  [3006 /* ADDRESS_NOT_FOUND */]: "\u6536\u8D27\u5730\u5740\u4E0D\u5B58\u5728",
  [3101 /* COUPON_UNAVAILABLE */]: "\u4F18\u60E0\u5238\u4E0D\u53EF\u7528",
  [3102 /* COUPON_BELOW_THRESHOLD */]: "\u8BA2\u5355\u91D1\u989D\u672A\u8FBE\u95E8\u69DB",
  [3103 /* COUPON_ALREADY_USED */]: "\u4F18\u60E0\u5238\u5DF2\u4F7F\u7528",
  [3104 /* POINTS_NOT_ENOUGH */]: "\u79EF\u5206\u4E0D\u8DB3",
  [3105 /* POINTS_OVER_LIMIT */]: "\u79EF\u5206\u62B5\u6263\u8D85\u51FA\u672C\u5355\u4E0A\u9650",
  [3106 /* AMOUNT_VERIFY_FAILED */]: "\u91D1\u989D\u6821\u9A8C\u5931\u8D25\uFF0C\u8BF7\u5237\u65B0\u9875\u9762\u91CD\u8BD5",
  [4001 /* PAYMENT_NOT_FOUND */]: "\u652F\u4ED8\u5355\u4E0D\u5B58\u5728",
  [4002 /* ORDER_ALREADY_PAID */]: "\u8BE5\u8BA2\u5355\u5DF2\u652F\u4ED8",
  [4003 /* NO_AVAILABLE_PAY_METHOD */]: "\u5F53\u524D\u73AF\u5883\u6682\u65E0\u53EF\u7528\u7684\u652F\u4ED8\u65B9\u5F0F",
  [4004 /* CHANNEL_CREATE_ORDER_FAILED */]: "\u652F\u4ED8\u4E0B\u5355\u5931\u8D25\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5",
  [4005 /* CHANNEL_RESPONSE_INVALID */]: "\u652F\u4ED8\u901A\u9053\u8FD4\u56DE\u5F02\u5E38",
  [4006 /* CHANNEL_NOT_CONFIGURED */]: "\u652F\u4ED8\u901A\u9053\u672A\u914D\u7F6E",
  [4007 /* CALLBACK_VERIFY_FAILED */]: "\u56DE\u8C03\u9A8C\u7B7E\u5931\u8D25",
  [4008 /* CALLBACK_AMOUNT_MISMATCH */]: "\u56DE\u8C03\u91D1\u989D\u4E0D\u4E00\u81F4",
  [5001 /* REFUND_AMOUNT_EXCEEDED */]: "\u9000\u6B3E\u91D1\u989D\u8D85\u51FA\u53EF\u9000\u91D1\u989D",
  [5002 /* ORDER_NOT_REFUNDABLE */]: "\u8BE5\u8BA2\u5355\u4E0D\u652F\u6301\u9000\u6B3E",
  [5003 /* CHANNEL_REFUND_FAILED */]: "\u9000\u6B3E\u5931\u8D25\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5",
  [5004 /* REFUND_NOT_FOUND */]: "\u9000\u6B3E\u5355\u4E0D\u5B58\u5728",
  [6001 /* EXPRESS_NOT_CONFIGURED */]: "\u5FEB\u9012100 \u672A\u914D\u7F6E\uFF0C\u8BF7\u8054\u7CFB\u7BA1\u7406\u5458",
  [6002 /* WAYBILL_CREATE_FAILED */]: "\u53D6\u53F7\u5931\u8D25\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5",
  [6003 /* EXPRESS_RESPONSE_INVALID */]: "\u5FEB\u9012100 \u8FD4\u56DE\u5F02\u5E38",
  [6004 /* EXPRESS_SIGN_FAILED */]: "\u5FEB\u9012100 \u9A8C\u7B7E\u5931\u8D25",
  [6005 /* WAYBILL_CANCEL_FAILED */]: "\u9762\u5355\u53D6\u6D88\u5931\u8D25\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5",
  [6006 /* WAYBILL_NOT_FOUND */]: "\u9762\u5355\u8BB0\u5F55\u4E0D\u5B58\u5728",
  [6007 /* WAYBILL_ALREADY_EXISTS */]: "\u8BE5\u8BA2\u5355\u5DF2\u53D6\u53F7\uFF0C\u8BF7\u52FF\u91CD\u590D\u53D6\u53F7",
  [6008 /* EXPRESS_SENDER_INCOMPLETE */]: "\u53D1\u8D27\u4EBA\u4FE1\u606F\u4E0D\u5B8C\u6574\uFF0C\u8BF7\u5148\u5728\u7CFB\u7EDF\u8BBE\u7F6E\u4E2D\u8865\u5168",
  [6009 /* EXPRESS_TEMPLATE_MISSING */]: "\u9762\u5355\u6A21\u677F\u672A\u914D\u7F6E",
  [6010 /* WAYBILL_NOT_PRINTABLE */]: "\u8BE5\u9762\u5355\u5F53\u524D\u72B6\u6001\u4E0D\u53EF\u6253\u5370",
  [9001 /* SYSTEM_BUSY */]: "\u7CFB\u7EDF\u7E41\u5FD9\uFF0C\u8BF7\u7A0D\u540E\u518D\u8BD5",
  [9002 /* DOWNSTREAM_TIMEOUT */]: "\u7F51\u7EDC\u8D85\u65F6\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5",
  [9003 /* NOT_IMPLEMENTED */]: "\u529F\u80FD\u5EFA\u8BBE\u4E2D"
};
function errMessage(code, fallback) {
  return fallback ?? ERR_MESSAGE[code] ?? "\u64CD\u4F5C\u5931\u8D25";
}
export {
  ERR_MESSAGE,
  ErrCode,
  errMessage
};
